import React from 'react';
import { ErrorModal, ConfirmationModal, SuccessModal, OpenAppModal } from '@/components/modals';
import { selectActiveModals } from '@/store/reducers/modals/modalsSlice';
import { Modal, ModalType } from '@/types/modals';
import { useAppSelector } from '@/store/hooks';

const MODALS: { [key in ModalType]: React.ElementType } = {
  [ModalType.ErrorModal]: ErrorModal,
  [ModalType.ConfirmationModal]: ConfirmationModal,
  [ModalType.SuccessModal]: SuccessModal,
  [ModalType.OpenAppModal]: OpenAppModal,
};

function ModalContent() {
  const activeModals: Modal[] = useAppSelector(selectActiveModals);

  return (
    <>
      {activeModals.map(({ type, componentProps }) => {
        const Modal = MODALS[type];

        return <Modal key={type} {...componentProps} />;
      })}
    </>
  );
}

export default ModalContent;
